import { createFileRoute, notFound, Outlet, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_authenticated/$orgId/reports/accounting-journal')({
  component: AccountingJournalLayout,
  loader: ({ context, params }) => {
    if (
      !context.ability.can('access', 'global') ||
      !context.ability.can('view', 'accounting-journal')
    ) {
      throw notFound()
    }

    // The journal belongs to one shop, so the global organization has none.
    if (Number(params.orgId) === Number(import.meta.env.VITE_TUKIOS_FLOWERS_ORG_ID)) {
      throw redirect({
        to: '/$orgId/reports',
        params: { orgId: params.orgId },
      })
    }
  },
})

function AccountingJournalLayout() {
  return <Outlet />
}
